import { IListIndicatorBionexo } from "models/ListIndicatorBionexo";
import { IRequestConfig } from "models/Axios";
import { IQuotesData, IQuotes } from "models/Quote";
import { formatISO } from "date-fns";
import axios from "axios";
import Services from "./index.service";
import qs from "qs";

export default class QuoteIndicatorSevices extends Services<
  IQuotesData,
  IQuotes
> {
  public DefaultIndicator = async (
    businessUnit?: string[],
    sellerCodes?: string[],
    categoriesId?: string[],
    status?: number[],
    supplierStatus?: number[],
    startDate?: Date | undefined,
    endDate?: Date | undefined,
    calendar?: boolean,
    origin?: string[],
    sentExpiredFilter?: boolean
  ) =>
    await this.FindIndicator(
      "Default",
      businessUnit,
      sellerCodes,
      categoriesId,
      status,
      supplierStatus,
      startDate,
      endDate,
      calendar,
      origin,
      sentExpiredFilter
    );

  public AvailableForQuote = async (
    businessUnit?: string[],
    sellerCodes?: string[],
    categoriesId?: string[],
    status?: number[],
    supplierStatus?: number[],
    startDate?: Date | undefined,
    endDate?: Date | undefined,
    calendar?: boolean,
    origin?: string[]
  ) =>
    await this.FindIndicator(
      "AvailableForQuote",
      businessUnit,
      sellerCodes,
      categoriesId,
      status,
      supplierStatus,
      startDate,
      endDate,
      calendar,
      origin
    );

  private FindIndicator = async (
    endpoint: string,
    businessUnitIdentifier?: string[],
    sellerCodes?: string[],
    categoriesId?: string[],
    status?: number[],
    supplierStatus?: number[],
    startDate?: Date | undefined,
    endDate?: Date | undefined,
    calendar?: boolean,
    origin?: string[],
    sentExpiredFilter?: boolean
  ) => {
    const config: IRequestConfig<IListIndicatorBionexo> = {
      url: `${this.mafraq_url}/Quotation/indicator/${endpoint}`,
      params: {
        startDate: startDate ? formatISO(startDate) : null,
        endDate: endDate ? formatISO(endDate) : null,
        sellerCodes: sellerCodes,
        productCategories: categoriesId,
        status: status,
        supplierStatus: supplierStatus,
        businessUnitIdentifier: businessUnitIdentifier,
        calendar: calendar,
        origin: origin,
        sentExpiredFilter: sentExpiredFilter
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { arrayFormat: "repeat", skipNulls: true }),
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    return new Promise<number>(async (resolve, reject) => {
      axios(config)
        .then((response) => { resolve(response.data); })
        .catch((error)=> { reject(error); })
    });
  };
}
